import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  bodyOverlay: false,
  isVerticalNavMenuActive: true,
  mainLayoutType: themeConfig.mainLayoutType || "vertical",
  navbarSearchAndPinList: navbarSearchAndPinList,
  reduceButton: themeConfig.sidebarCollapsed,
  verticalNavMenuWidth: "default",
  verticalNavMenuItemsMin: false,
  scrollY: 0,
  starredPages: navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
  theme: themeConfig.theme || "light",
  themePrimaryColor: colors.primary,
  windowWidth: null,

  // authentication
  isAuthenticated: false,
  loginError: null,
  tokens: {
    access: localStorage.getItem('accessToken'),
    refresh: localStorage.getItem('refreshToken'),
  },
  endpoints: {
    baseUrl: process.env.NODE_ENV === 'production' ? 'https://storagevault.onrender.com/management/api/' : 'http://127.0.0.1:8050/management/api/',
    obtainJWT: process.env.NODE_ENV === 'production' ? 'https://storagevault.onrender.com/management/api/token/' : 'http://127.0.0.1:8050/management/api/token/',
    refreshJWT: process.env.NODE_ENV === 'production' ? 'https://storagevault.onrender.com/management/api/token/refresh/' : 'http://127.0.0.1:8050/management/api/token/refresh/',
  },

  // app logic

  user: null,
  homeData: null,
}

export default state
